/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'people.menu.renotify.flag.description':
    "Stiamo inviando a tutti un'e-mail di promemoria. L'operazione può richiedere fino a un minuto.",
  'people.menu.renotify.flag.description.confluence': 'Ricorda ai colleghi',
  'people.menu.renotify.flag.title': 'Invio dei promemoria in corso',
  'people.menu.renotify.flag.title.confluence': "Invia nuovamente l'e-mail di invito",
  'people.menu.renotify.menu.description':
    "{userCount, plural, one {{userCount,number} persona non ha accettato l'invito in {product}. Scopri chi manca e invia un promemoria.} other {{userCount,number} persone non hanno accettato l'invito in {product}. Scopri chi manca e invia un promemoria.}}",
  'people.menu.renotify.menu.description.confluence':
    "Alcune persone non hanno accettato l'invito in Confluence. Scopri chi manca e invia un promemoria.",
  'people.menu.renotify.menu.dismiss': 'Chiudi',
  'people.menu.renotify.menu.dismiss.confluence': 'Non ora',
  'people.menu.renotify.menu.remind': 'Ricordalo ai membri del team',
  'people.menu.renotify.menu.remind.confluence': 'Ricorda ai colleghi',
  'people.menu.renotify.menu.title': 'Sono tutti a bordo?',
  'people.menu.renotify.modal.copied': 'Link copiato',
  'people.menu.renotify.modal.copy': 'Copia il link di invito',
  'people.menu.renotify.modal.description':
    "Possiamo inviare un'e-mail di promemoria ai membri mancanti, oppure puoi condividere personalmente il link di invito.",
  'people.menu.renotify.modal.description.confluence':
    "Invia di nuovo l'e-mail di invito oppure copia e condividi il link di invito.",
  'people.menu.renotify.modal.dismiss': 'Annulla',
  'people.menu.renotify.modal.resend': 'Invia un promemoria',
  'people.menu.renotify.modal.resend.confluence': "Invia nuovamente l'invito",
  'people.menu.renotify.modal.title': 'Ricordalo ai membri mancanti',
  'people.menu.renotify.modal.title.confluence': 'Ricordalo ai colleghi mancanti',
  'ptc.pm.collaborators.title': 'I tuoi collaboratori',
  'ptc.pm.error-heading': 'Si è verificato un problema',
  'ptc.pm.error-image-alt-text': 'Un robot guasto e diverse persone impegnate ad aggiustarlo.',
  'ptc.pm.error-text':
    'Questi errori vengono monitorati, ma contattaci pure se ricaricando la pagina il problema non si risolve',
  'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} membro} other {{memberCount,number} membri}}',
  'ptc.pm.people': 'Persone',
  'ptc.pm.teams': 'Team',
  'ptc.pm.view-your-profile': 'Visualizza il tuo profilo',
  'ptc.pm.your-teams.title': 'I tuoi team',
};
